import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {BillingConfiguration} from '../../seguridad/emisor/recursos/modelo/emisor-configuration';
import {TipoDocumento} from '../../seguridad/emisor/recursos/modelo/tipo-documento.enum';
import {Observable} from '../../../../../../node_modules/rxjs/Observable';
import {debounceTime, map, startWith} from '../../../../../../node_modules/rxjs/operators';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {StockProducts} from '../../seguridad/emisor/recursos/modelo/stockProducts';
import {MatSnackBar} from '@angular/material';
import {Receiver} from '../../seguridad/emisor/recursos/modelo/Receiver';
import {MeasurementUnits} from '../../seguridad/emisor/recursos/modelo/MeasurementUnits';
import {Emi} from 'app/layout/content/emisorFacturas/recursos/modelo/Emi';
import {COMMA, ENTER} from '@angular/cdk/keycodes';

import {LogEmisor} from '../../transaccion/logEmisorTmp/recursos/modelo/LogEmisor';
import {Dde} from '../recursos/modelo/dde';
import {Grc} from '../recursos/modelo/grc';
import {Gca} from '../recursos/modelo/gca';
import {Ubigeo} from '../../../../../assets/data/ubigeo';
import {Grd} from '../recursos/modelo/grd';
import {GrePoint} from '../../seguridad/emisor/recursos/modelo/gre-point';
import {GreCarrier} from '../../seguridad/emisor/recursos/modelo/gre-carrier';
import {Ide} from "../recursos/modelo/ide";
import { getDocumentInfo } from '../util/util-type-name';

declare var $: any;
declare var swal: any;


@Component({
    selector: 'app-guia_remision',
    templateUrl: './view/guia-remision.component.html',
    styleUrls: ['./css/guia-remision.component.scss'],
    providers: [AuthService, ConsumerService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GuiaRemisionComponent implements OnInit {

    /**
     * PARAMETROS DE CONFIGURACION GENERAL
     *
     */
    @Input() documento;
    IGV = 18.0;
    RUC = '6';
    DND = '0';
    DNI = '1';
    CARNET_EXTRAJERIA = '4';
    PASAPORTE = '7';
    /**
     *
     * DEPARTAMENTO, DISTRITO, PROVINCIA
     *
     */

    masterStartingPointUbigeo;
    masterDestinationPointUbigeo;

    startingPointDepartamento = 'Selecione Departamento';
    startingPointProvincia = 'Selecione Provincia';
    startingPointDistrito = 'Selecione Distrito';


    destinationPointDepartamento = 'Selecione Departamento';
    destinationPointProvincia = 'Selecione Provincia';
    destinationPointDistrito = 'Selecione Distrito';
    /**
     * PARAMETROS DE CARGA = LOADING
     *
     */
    loadingConsultas = [
        {
            modulo: 'Cargando Series',
            cargando: true
        },
        {
            modulo: 'Cargando Clientes',
            cargando: false
        },
        {
            modulo: 'Cargando Productos',
            cargando: false
        },
        {
            modulo: 'Cargando Puntos de llegada y partida',
            cargando: false
        },
        {
            modulo: 'Cargando Transportistas',
            cargando: false
        }
    ];
    loading_documento = false;
    loading_popup = false;


    mensaje = '';
    error = false;

    /**
     * FORMULARIOS Y VALIDADORES
     *
     */
    formGuiaRemision: FormGroup;
    formReceptor: FormGroup;
    formAdditionalPermanent: FormGroup;
    formAdditionalTemp: FormGroup;
    formChangeAmountOrDate: FormGroup;
    formReceptorNuevo: FormGroup;
    formProductoNuevo: FormGroup;

    vld_serie: FormControl;
    vld_fecha_vencimiento: FormControl;
    vld_fecha_inicio_traslado: FormControl;
    vld_rucReceptor: FormControl;
    vld_peso_bruto_bienes: FormControl;
    vld_numero_bultos: FormControl;
    vld_aux_telefono: FormControl;
    vld_aux_correo: FormControl;
    vld_aux_razonSocial: FormControl;
    vld_aux_direccion: FormControl;
    vld_item: FormControl;

    // RECEPTOR NUEVO
    vld_tipoReceptorNuevo: FormControl;
    vld_rucReceptorNuevo: FormControl;
    vld_TelefonoReceptorNuevo: FormControl;
    vld_CorreoReceptorNuevo: FormControl;
    vld_NameReceptorNuevo: FormControl;
    vld_DireccionReceptorNuevo: FormControl;

    // PRODUCTO NUEVO
    vld_codigoProductoNuevo: FormControl;
    vld_descripcionProductoNuevo: FormControl;
    vld_valorProductoNuevo: FormControl;

    serieControl = new FormControl();
    rucControl = new FormControl();
    itemControl = new FormControl();

    vdl_startingPoint = new FormControl();
    vdl_startingPointAddress = new FormControl();
    vld_destinationPoint = new FormControl();
    vld_destinationPointAddress = new FormControl();
    vld_codEstabPuntoLlegada = new FormControl();
    vld_codEstabPuntoPartida = new FormControl();

    vld_placaNumber = new FormControl();
    vld_rucConductor = new FormControl();
    vld_docConductor = new FormControl();
    vld_numberMTC = new FormControl();
    vld_denominacionTransportador = new FormControl();
    vld_fechaEntregaBienesAlTranportista = new FormControl();
    vld_observationes = new FormControl();
    vld_precinto2 = new FormControl();
    vld_numContenedor2 = new FormControl();
    vld_precinto1 = new FormControl();
    vld_numContenedor1 = new FormControl();

    vld_principalNombre = new FormControl();
    vld_principalApellido = new FormControl();
    vld_numLicCondConductor = new FormControl();

    aux_correo = '';
    aux_direccion = '';
    aux_razonSocial = '';
    aux_item = '';
    aux_telefono = '';

    /**
     * VARIABLES DE CONTROL DE VISUALIZACION
     *
     */
    editarReceptor = false;
    bsConfig: Partial<BsDatepickerConfig>;
    bsConfigV2: Partial<BsDatepickerConfig>;
    colorTheme = 'theme-dark-blue';
    agregarShowItem = false;
    agregarShowReceptor = false;
    popupReceptor = false;
    popupProducto = false;

    /**
     * VARIABLES DE DATA
     *
     */
    items: FormArray;
    options: String[] = [];
    reasonTransfer: any[] = [];
    reasonTransferValue = {code: '01', description: '01 - Venta'};
    trasladoType: any[] = [];
    trasladoTypeValue = {code: '01', description: '01 - Público'};
    tipoDoc = '09';
    usuarioSession: any;
    receivers: Receiver[] = [];
    optionsRuc: Receiver[] = [];
    optionsCodePointStarting: GrePoint[] = [];
    optionsCodePointArrival: GrePoint[] = [];
    optionsCarrierRuc: GreCarrier[] = [];
    optionsItem: StockProducts[] = [];
    filteredOptionsSerie: Observable<String[]>;
    filteredOptionsRuc: Observable<Receiver[]>;
    filteredOptionsCodeStarting: Observable<GrePoint[]>;
    filteredOptionsAddressStarting: Observable<GrePoint[]>;
    filteredOptionsCodeArrival: Observable<GrePoint[]>;
    filteredOptionsAddressArrival: Observable<GrePoint[]>;

    filteredOptionsCarrierRuc: Observable<GreCarrier[]>;
    filteredOptionsCarrierDoc: Observable<GreCarrier[]>;
    filteredOptionsItem: Observable<StockProducts[]>;
    popup_text = '';
    docType: any[] = [];
    docTypeDriver: any[] = [];
    receptorNuevo: Receiver = new Receiver();
    productoNuevo: StockProducts = new StockProducts();

    /**
     *  TEMPLATE JSON GUIA REMISION
     */
    template_guiaRemision = this.nuevaGuiaRemision();
    typeDocument: any = {value: this.RUC, label: 'RUC'};
    typeDocumentDriver: any = {value: this.RUC, label: 'RUC'};
    disabledTypeDocument = false;

    vld_additionalTempKey: FormControl;
    vld_additionalTempValue: FormControl;
    vld_additionalPermanentKey: FormControl;
    vld_additionalPermanentValue: FormControl;

    keyTemp = '';
    valueTemp = '';
    keyPermanent = '';
    valuePermanent = '';
    // DATOS ADICIONALES
    additionalDataPermanent = [];
    additionalDataTmp = [];
    selectable = true;
    removable = true;
    addOnBlur = true;
    separatorKeysCodes = [ENTER, COMMA];
    loadingAddDataAditional = false;
    removeAdditionalPermanent = false;
    preview = false;
    step = 0;

    showCreationSummary = false;
    messageCreation = '';
    logSeleccionado = new LogEmisor();
    cargaDocumentos = false;

    constructor(private util: UtilConfig,
                private cd: ChangeDetectorRef,
                private fb: FormBuilder,
                private router: Router,
                private consumerService: ConsumerService,
                private snackBar: MatSnackBar) {
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;

        this.masterStartingPointUbigeo = new Ubigeo();
        this.masterDestinationPointUbigeo = new Ubigeo();

        this.createFormControls();
        this.createFormGuiaRemision();
        this.createFormReceptor();
        this.createFormReceptorNuevo();
        this.createFormProductoNuevo();
        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD',
            minDate: moment().subtract(5, 'd').toDate(),
            maxDate: moment().add(2, 'd').toDate()
        });
        this.bsConfigV2 = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD',
            minDate: moment().toDate(),
            maxDate: moment().add(10, 'd').toDate()
        });
        this.reasonTransfer = [];
        this.reasonTransfer.push({description: '01 - Venta', code: '01'});
        this.reasonTransfer.push({description: '02 - Compra', code: '02'});
        this.reasonTransfer.push({description: '04 - Traslado entre establecimientos de la misma empresa', code: '04'});
        this.reasonTransfer.push({description: '13 - Otros', code: '13'});

        this.trasladoType = [];
        this.trasladoType.push({description: '01 - Público', code: '01'});
        this.trasladoType.push({description: '02 - Privado', code: '02'});

        this.optionsRuc = [];
        this.docType.push({value: this.DNI, label: 'DNI'});
        this.docType.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
        this.docType.push({value: this.PASAPORTE, label: 'Pasaporte'});
        this.docType.push({value: this.RUC, label: 'RUC'});
        this.docType.push({value: this.DND, label: 'DND'});

        this.docTypeDriver.push({value: this.DNI, label: 'DNI'});
        this.docTypeDriver.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
        this.docTypeDriver.push({value: this.PASAPORTE, label: 'Pasaporte'});
        this.docTypeDriver.push({value: this.RUC, label: 'RUC'});
        this.docTypeDriver.push({value: this.DND, label: 'DND'});

        this.productoNuevo.affectationIGV = 'GRAVADO';

        const unit = new MeasurementUnits();
        unit.code = 'NIU';
        unit.description = 'number of international units';
        unit.label = 'Unidades';

        this.productoNuevo.measurementUnit = unit;
    }

    setStep(index: number) {
        this.step = index;
    }

    ngOnInit(): void {
        this.getSeries();
        this.getAdditionalDataPermanent();
        this.getReceptores();
        this.getPoints();
        this.getCarriers();
        this.getItems();
        this.template_guiaRemision.guiaRemision.det = [];
        this.filteredOptionsSerie = this.serieControl.valueChanges
            .pipe(
                startWith(''), debounceTime(500),
                map(value => {
                    return (value) ? this._filter(value) : this.options.slice();
                }));
        this.filteredOptionsRuc = this.rucControl.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterRuc(value) : this.optionsRuc.filter(item => item.idDocType == this.typeDocument.value).slice();
            }));

        this.filteredOptionsCodeStarting = this.vld_codEstabPuntoPartida.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterCodePointStarting(value) : this.optionsCodePointStarting.slice();
            }));

        this.filteredOptionsAddressStarting = this.vdl_startingPointAddress.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterAddressPointStarting(value) : this.optionsCodePointStarting.slice();
            }));

        this.filteredOptionsCodeArrival = this.vld_codEstabPuntoLlegada.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterCodePointArrival(value) : this.optionsCodePointArrival.slice();
            }));

        this.filteredOptionsAddressArrival = this.vld_destinationPointAddress.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterAddressPointArrival(value) : this.optionsCodePointArrival.slice();
            }));

        this.filteredOptionsCarrierRuc = this.vld_rucConductor.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterCarrierRuc(value) :
                    this.optionsCarrierRuc.filter(item => item.type === 'PUBLIC').slice();
            }));


        this.filteredOptionsCarrierDoc = this.vld_docConductor.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterCarrierDoc(value) :
                    this.optionsCarrierRuc.filter(item => item.type === 'PRIVATE' && item.documentType == this.typeDocumentDriver.value).slice();
            }));


        this.filteredOptionsItem = this.itemControl.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterItem(value) : this.optionsItem.slice();
            }));
        this.changeReasonTransferValue(this.reasonTransferValue);
        this.setDepProDistStartingPoint();

    }

    cargarTypeDocuments(docType: any) {
        this.typeDocument = docType;
        this.filterReceptores();
        this.template_guiaRemision.guiaRemision.dde.numeroDocId = '';
    }

    getSize() {
        let size = 15;
        if ('1' === this.typeDocumentDriver.value) {
            size = 8;
            return size;
        }
        if ('6' === this.typeDocumentDriver.value) {
            size = 11;
            return size;
        }
        return size;
    }

    cargarTypeDocumentsDriver(docType: any) {
        this.typeDocumentDriver = docType;
        this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor = '';
        this.template_guiaRemision.guiaRemision.gca.nomConductor = '';
        this.template_guiaRemision.guiaRemision.gca.apeConductor = '';
        this.template_guiaRemision.guiaRemision.gca.numLicCondConductor = '';
    }


    getItems() {
        this.loadingConsultas[2].cargando = true;
        if (this.util.getProductList() != null) {
            this.optionsItem = [];
            $.each(JSON.parse(this.util.getProductList()), (pos, item) => {
                this.optionsItem.push(item);
            });
            this.loadingConsultas[2].cargando = false;
        }
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumerService.post<any>(WebServices.URL_GET_ITEMS, body)
            .subscribe(result => {
                const productos: any = result['productsStocks'];
                this.util.setProductList(productos);
                if (productos != null && productos.length > 0) {
                    this.optionsItem = [];
                    $.each(productos, (pos, item) => {
                        this.optionsItem.push(item);
                    });
                }
                this.loadingConsultas[2].cargando = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[2].cargando = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
                console.log('no se cargaron las productos');
            });

    }

    getReceptores() {
        this.optionsRuc = [];
        this.loadingConsultas[1].cargando = true;
        this.consumerService.search<any>('', 'ACTIVO', WebServices.URL_GET_RECEPTORES)
            .subscribe(result => {
                this.loadingConsultas[1].cargando = false;
                if (result['codigo'] === 1) {
                    this.receivers = result['receivers'];
                    this.filterReceptores();
                }
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[1].cargando = false;
                console.log('no se cargaron los receptores');
                this.cd.markForCheck();
                this.cd.detectChanges();
            });

    }

    getPoints() {
        this.optionsCodePointStarting = [];
        this.optionsCodePointArrival = [];
        this.loadingConsultas[3].cargando = true;
        this.consumerService.search<any>('', 'ACTIVO', WebServices.URL_GET_POINTS)
            .subscribe(result => {
                this.loadingConsultas[3].cargando = false;
                if (result.codigo === 1) {
                    this.optionsCodePointStarting = result['grepoints'].filter(item => item.startingPoint === 'SI' || item.startingPoint === true);
                    this.optionsCodePointArrival = result['grepoints'].filter(item => item.arrivalPoint === 'SI' || item.arrivalPoint === true);
                }
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[3].cargando = false;
                console.log('no se cargaron los puntos');
                this.cd.markForCheck();
                this.cd.detectChanges();
            });

    }

    getCarriers() {
        this.optionsCarrierRuc = [];
        this.loadingConsultas[4].cargando = true;
        this.consumerService.search<any>('', 'ACTIVO', WebServices.URL_GET_CARRIER)
            .subscribe(result => {
                this.loadingConsultas[4].cargando = false;
                if (result.codigo === 1) {
                    this.optionsCarrierRuc = result['grecarriers'];
                }
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[4].cargando = false;
                console.log('no se cargaron los puntos');
                this.cd.markForCheck();
                this.cd.detectChanges();
            });

    }


    private filterReceptores() {
        if (this.receivers != null && this.receivers.length > 0) {
            this.optionsRuc = [];
            $.each(this.receivers, (pos, item) => {

                if (item.idDocType === this.typeDocument.value) {
                    const receptor = new Receiver();
                    receptor.idDocType = item.idDocType;
                    receptor.idDocNumber = item.idDocNumber;
                    receptor.businessName = item.businessName;
                    receptor.phone = item.phone;
                    receptor.email = item.email;
                    receptor.address = item.address;
                    this.optionsRuc.push(receptor);
                }
            });
            $('.espacioCliente').animate({
                opacity: 0
            }, 1000);
            this.filteredOptionsRuc = this.rucControl.valueChanges
                .pipe(startWith(''), debounceTime(500), map(value => {
                    return (value) ? this._filterRuc(value) : this.optionsRuc.filter(item => item.idDocType == this.typeDocument.value).slice();
                }));
            this.cd.detectChanges();
            this.cd.markForCheck();
        }
    }

    createFormControls() {
        this.serieControl = new FormControl({value: ''}, [Validators.required]);
        this.vld_serie = new FormControl({value: ''}, [Validators.required]);
        this.vld_fecha_vencimiento = new FormControl({value: ''}, [Validators.required]);
        this.vld_fecha_inicio_traslado = new FormControl({value: ''}, [Validators.required]);
        this.vld_peso_bruto_bienes = new FormControl({value: ''}, [Validators.required]);
        this.vld_numero_bultos = new FormControl({value: ''}, [Validators.required]);

        this.vld_rucReceptor = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_aux_correo = new FormControl({}, [Validators.required]);
        this.vld_aux_direccion = new FormControl({}, [Validators.required]);
        this.vld_aux_telefono = new FormControl({}, [Validators.required]);
        this.vld_aux_razonSocial = new FormControl({}, [Validators.required]);


        this.vld_tipoReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_rucReceptorNuevo = new FormControl({value: ''}, [Validators.required, Validators.minLength(11), Validators.maxLength(15)]);
        this.vld_NameReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_CorreoReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_TelefonoReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_DireccionReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_item = new FormControl({}, [Validators.nullValidator]);

        this.vld_codigoProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_descripcionProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_valorProductoNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vdl_startingPoint = new FormControl({value: ''}, [Validators.required]);
        this.vdl_startingPointAddress = new FormControl({value: ''}, [Validators.required]);
        this.vld_destinationPoint = new FormControl({value: ''}, [Validators.required]);
        this.vld_destinationPointAddress = new FormControl({value: ''}, [Validators.required]);
        this.vld_codEstabPuntoPartida = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_codEstabPuntoLlegada = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_placaNumber = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_rucConductor = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_docConductor = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_numberMTC = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_denominacionTransportador = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_fechaEntregaBienesAlTranportista = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_observationes = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_numContenedor1 = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_precinto1 = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_numContenedor2 = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_precinto2 = new FormControl({value: ''}, [Validators.nullValidator]);


        this.vld_principalNombre = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_principalApellido = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_numLicCondConductor = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_additionalTempKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalTempValue = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentValue = new FormControl({value: ''}, [Validators.nullValidator]);
    }

    createFormGuiaRemision() {
        this.formGuiaRemision = this.fb.group({
            'serie': this.vld_serie,
            'fechaEmision': this.vld_fecha_vencimiento,
            'fechaInicioTraslado': this.vld_fecha_inicio_traslado,
            'pesoBrutoBienes': this.vld_peso_bruto_bienes,
            'numeroBultos': this.vld_numero_bultos,
            'rucReceptor': this.vld_rucReceptor,
            'items': this.fb.array([]),
            'item': this.vld_item,
            'startingPoint': this.vdl_startingPoint,
            'startingPointAddress': this.vdl_startingPointAddress,
            'destinationPoint': this.vld_destinationPoint,
            'destinationPointAddress': this.vld_destinationPointAddress,
            'codEstabPuntoPartida': this.vld_codEstabPuntoPartida,
            'codEstabPuntoLlegada': this.vld_codEstabPuntoLlegada,
            'docConductorRuc': this.vld_rucConductor,
            'docConductor': this.vld_docConductor,
            'numberMTC': this.vld_numberMTC,
            'placaNumber': this.vld_placaNumber,
            'denominacionTransportador': this.vld_denominacionTransportador,
            'fechaEntregaBienesAlTranportista': this.vld_fechaEntregaBienesAlTranportista,
            'numContenedor1': this.vld_numContenedor1,
            'numPrecinto1': this.vld_precinto1,
            'numContenedor2': this.vld_numContenedor2,
            'numPrecinto2': this.vld_precinto2,
            'observationes': this.vld_observationes,
            'principalNombre': this.vld_principalNombre,
            'principalApellido': this.vld_principalApellido,
            'numLicCondConductor': this.vld_numLicCondConductor,
        });

        this.formAdditionalPermanent = this.fb.group({
            'key': this.vld_additionalPermanentKey,
            'value': this.vld_additionalPermanentValue,
        });
        this.formAdditionalTemp = this.fb.group({
            'key': this.vld_additionalTempKey,
            'value': this.vld_additionalTempValue,
        });
    }


    createFormReceptor() {
        this.formReceptor = this.fb.group({
            'razonSocial': this.vld_aux_razonSocial,
            'correoReceptor': this.vld_aux_correo,
            'direccionReceptor': this.vld_aux_direccion,
            'telefonoReceptor': this.vld_aux_telefono
        });
    }

    createFormReceptorNuevo() {
        this.formReceptorNuevo = this.fb.group({
            'idDocType': this.vld_tipoReceptorNuevo,
            'idDocNumber': this.vld_rucReceptorNuevo,
            'businessName': this.vld_NameReceptorNuevo,
            'email': this.vld_CorreoReceptorNuevo,
            'phone': this.vld_TelefonoReceptorNuevo,
            'address': this.vld_DireccionReceptorNuevo
        });
    }

    createFormProductoNuevo() {
        this.formProductoNuevo = this.fb.group({
            'codigo': this.vld_codigoProductoNuevo,
            'descripcion': this.vld_descripcionProductoNuevo,
            'valor': this.vld_valorProductoNuevo
        });
    }


    createItem(): FormGroup {
        return this.fb.group({
            'codigo': '',
            'description': '',
            'cantidad': '',
            'unidad': '',
            'valor': '',
            'descuento': '',
            'igv': '',
            'precioVentaUnitario': '',
            'valorTotal': '',
        });
    }

    removeItem(pos) {
        this.template_guiaRemision.guiaRemision.grd.splice(pos, 1);
        this.items.removeAt(pos);

        $.each(this.template_guiaRemision.guiaRemision.det, (pos1, item) => {
            item.numeroItem = pos1 + 1;
        });
    }

    onSubmitGuiaRemision() {
        this.error = false;
        this.mensaje = '';

        if (this.formGuiaRemision.valid) {
            this.generarDocumentoGuiaRemision();
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }

    generarPreview() {
        this.generatePreCreateDocument();
        this.preview = true;
        this.cd.markForCheck();
        this.cd.detectChanges();
    }


    private generatePreCreateDocument() {
        this.template_guiaRemision.guiaRemision.ide.tipoMoneda = null;
        this.template_guiaRemision.guiaRemision.ide.formaPago = null;
        this.clearField();

        this.template_guiaRemision = this.util.removeAllBlankOrNull_asString(this.template_guiaRemision);
        const body: any = {
            despatchAdviceTemplate: {
                guiaRemision: this.template_guiaRemision.guiaRemision
            },
            documentType: this.tipoDoc,
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc
            }
        };

        // IDE
        body.despatchAdviceTemplate.guiaRemision.ide.fechaEmision =
            moment(body.despatchAdviceTemplate.guiaRemision.ide.fechaEmision).format('YYYY-MM-DD');

        // DDE
        this.createDDE(body);

        // GRC
        this.createGRC(body);

        // GCA
        this.createGCA(body);
        // ADI
        this.generarADI();

        return body;
    }

    clearField() {
        if (this.trasladoTypeValue.code === '01') {
            this.template_guiaRemision.guiaRemision.grc.fechaInicioTraslado = null;
            this.template_guiaRemision.guiaRemision.grc.numeroPlacaVehiculo = null;
            this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor = null;
            this.template_guiaRemision.guiaRemision.gca.nomConductor = null;
            this.template_guiaRemision.guiaRemision.gca.apeConductor = null;
            this.template_guiaRemision.guiaRemision.gca.numLicCondConductor = null;
        }
        if (this.trasladoTypeValue.code === '02') {
            this.template_guiaRemision.guiaRemision.grc.denominacionTransportador = null;
            this.template_guiaRemision.guiaRemision.grc.numeroRucTransportista = null;
            this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC = null;
            this.template_guiaRemision.guiaRemision.gca.fechaEntregaBienesAlTranportista = null;
        }
    }


    generarDocumentoGuiaRemision() {
        const body = this.generatePreCreateDocument();
        if (this.reasonTransferValue.code === '13' &&
            !this.isTheCorrectFormatCampoObservacion(this.template_guiaRemision.guiaRemision.ide.notasCaso)) {
            swal(
                'No se pudo crear la guiaRemision',
                'El campo observación es diferente a alfanumérico de 3 hasta 100 caracteres (se considera cualquier ' +
                'carácter incluido espacio, no se permite ningún otro \'whitespace character\': salto de línea, tab, ' +
                'fin de línea, etc.',
                'error'
            );
            return false;
        }
        this.loading_documento = true;
        this.cd.markForCheck();
        this.cd.detectChanges();
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, body)
            .subscribe(result => {
                this.loading_documento = false;
                this.scroll('listDocuments');
                this.cd.markForCheck();
                this.cd.detectChanges();
                if (result.codigo !== 1) {
                    swal(
                        'No se pudo crear la guiaRemision',
                        result.mensaje,
                        'error'
                    );
                } else {
                    this.messageCreation = result.mensaje;
                    this.template_guiaRemision.guiaRemision.ide.numeracion = getDocumentInfo(result.mensaje, 'T');
                    this.showCreationSummary = true;
                    this.getIdByName(this.template_guiaRemision.guiaRemision.ide.numeracion);

                }
                this.setStep(0);
                this.preview = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loading_documento = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el documento', this.router);
            });
    }


    private createDDE(body: any) {
        if (this.reasonTransferValue.code === '04' || this.reasonTransferValue.code === '02') {
            body.despatchAdviceTemplate.guiaRemision.dde.tipoDocId = body.despatchAdviceTemplate.guiaRemision.emi.tipoDocId;
            body.despatchAdviceTemplate.guiaRemision.dde.numeroDocId = body.despatchAdviceTemplate.guiaRemision.emi.numeroDocId;
            body.despatchAdviceTemplate.guiaRemision.dde.nombreComercial = body.despatchAdviceTemplate.guiaRemision.emi.nombreComercial;
            body.despatchAdviceTemplate.guiaRemision.dde.razonSocial = body.despatchAdviceTemplate.guiaRemision.emi.razonSocial;
            body.despatchAdviceTemplate.guiaRemision.dde.ubigeo = body.despatchAdviceTemplate.guiaRemision.emi.ubigeo;
            body.despatchAdviceTemplate.guiaRemision.dde.direccion = body.despatchAdviceTemplate.guiaRemision.emi.direccion;
            body.despatchAdviceTemplate.guiaRemision.dde.urbanizacion = body.despatchAdviceTemplate.guiaRemision.emi.urbanizacion;
            body.despatchAdviceTemplate.guiaRemision.dde.provincia = body.despatchAdviceTemplate.guiaRemision.emi.provincia;
            body.despatchAdviceTemplate.guiaRemision.dde.departamento = body.despatchAdviceTemplate.guiaRemision.emi.departamento;
            body.despatchAdviceTemplate.guiaRemision.dde.distrito = body.despatchAdviceTemplate.guiaRemision.emi.distrito;
            body.despatchAdviceTemplate.guiaRemision.dde.codigoPais = body.despatchAdviceTemplate.guiaRemision.emi.codigoPais;
        }
    }

    private createGRC(body: any) {
        body.despatchAdviceTemplate.guiaRemision.grc.idTraslado = 'SUNAT_Envio';
        body.despatchAdviceTemplate.guiaRemision.grc.motivoTraslado = this.reasonTransferValue.code;
        body.despatchAdviceTemplate.guiaRemision.grc.descripcionMotivoTraslado = this.reasonTransferValue.description.split(' ')[2];
        body.despatchAdviceTemplate.guiaRemision.grc.modalidadTraslado = this.trasladoTypeValue.code;
        body.despatchAdviceTemplate.guiaRemision.grc.unidadMedidaPesoBruto = 'KGM';
        if (this.typeDocumentDriver.value === '6') {
            body.despatchAdviceTemplate.guiaRemision.grc.tipoDocTransportista = this.typeDocumentDriver.value;
        } else {
            body.despatchAdviceTemplate.guiaRemision.grc.tipoDocIdeConductor = this.typeDocumentDriver.value;
        }
        body.despatchAdviceTemplate.guiaRemision.grc.fechaInicioTraslado =
            moment(body.despatchAdviceTemplate.guiaRemision.grc.fechaInicioTraslado).format('YYYY-MM-DD');

        if (this.trasladoTypeValue.code === '02') { // trasporte privado
            if (body.despatchAdviceTemplate.guiaRemision.grc.numeroPlacaVehiculo !== '') {
                body.despatchAdviceTemplate.guiaRemision.grc.numeroPlacaVehiculo =
                    body.despatchAdviceTemplate.guiaRemision.grc.numeroPlacaVehiculo.toUpperCase();
            }
        }
    }

    private createGCA(body: any) {
        body.despatchAdviceTemplate.guiaRemision.gca.indicadorTrasladoVehiculoM1L = 'SUNAT_Envio_IndicadorTrasladoVehiculoM1L';
        if (this.reasonTransferValue.code === '01') { // VENTA
            body.despatchAdviceTemplate.guiaRemision.gca.numRUCPuntoPartida = null;
            body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoPartida
                = null;
            body.despatchAdviceTemplate.guiaRemision.gca.numRUCPuntoLlegada = null;
            body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoLlegada = null;
        }

        if (this.reasonTransferValue.code === '04' || this.reasonTransferValue.code === '02' || this.reasonTransferValue.code === '13') { // TRASLADO
            body.despatchAdviceTemplate.guiaRemision.gca.numRUCPuntoPartida = body.despatchAdviceTemplate.guiaRemision.emi.numeroDocId;
            body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoPartida =
                (body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoPartida === '') ? '0000' :
                    body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoPartida;
            body.despatchAdviceTemplate.guiaRemision.gca.numRUCPuntoLlegada = body.despatchAdviceTemplate.guiaRemision.emi.numeroDocId;
            body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoLlegada =
                (body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoLlegada === '') ? '0000' :
                    body.despatchAdviceTemplate.guiaRemision.gca.codEstabPuntoLlegada;
        }


        if (this.trasladoTypeValue.code === '02') { // PRIVADO
            if (
                (body.despatchAdviceTemplate.guiaRemision.gca.nomConductor !== '' &&
                    body.despatchAdviceTemplate.guiaRemision.gca.nomConductor !== undefined) ||
                (body.despatchAdviceTemplate.guiaRemision.gca.apeConductor !== '' &&
                    body.despatchAdviceTemplate.guiaRemision.gca.apeConductor !== undefined) ||
                (body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor !== '' &&
                    body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor !== undefined)
            ) {
                body.despatchAdviceTemplate.guiaRemision.gca.tipoConductor = 'Principal';
                if ((body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor !== '' &&
                    body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor !== undefined)) {
                    body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor =
                        body.despatchAdviceTemplate.guiaRemision.gca.numLicCondConductor.toUpperCase();
                }
            }
        } else {
            if (body.despatchAdviceTemplate.guiaRemision.gca.fechaEntregaBienesAlTranportista != null &&
                body.despatchAdviceTemplate.guiaRemision.gca.fechaEntregaBienesAlTranportista.toString() !== '') {
                body.despatchAdviceTemplate.guiaRemision.gca.fechaEntregaBienesAlTranportista =
                    moment(body.despatchAdviceTemplate.guiaRemision.gca.fechaEntregaBienesAlTranportista).format('YYYY-MM-DD');
            }
        }


    }

    private resetDocument(event) {
        this.template_guiaRemision = this.nuevaGuiaRemision();
        // SE DEFINE QUE TIPO OPERACION VENTA INTERNA VA DE PRIMERO⁄⁄
        this.reasonTransferValue = {code: '01', description: '01 - Venta'};
        this.trasladoTypeValue = {code: '01', description: '01 - Público'};
        this.typeDocument = {value: this.RUC, label: 'RUC'};
        this.typeDocumentDriver = {value: this.RUC, label: 'RUC'};
        this.showCreationSummary = false;
        this.startingPointDepartamento = 'Selecione Departamento';
        this.startingPointProvincia = 'Selecione Provincia';
        this.startingPointDistrito = 'Selecione Distrito';
        this.destinationPointDepartamento = 'Selecione Departamento';
        this.destinationPointProvincia = 'Selecione Provincia';
        this.destinationPointDistrito = 'Selecione Distrito';
        this.preview = false;
        $('.espacioCliente').animate({
            opacity: 0
        }, 500);
        this.cd.markForCheck();
        this.cd.detectChanges();
    }


    getSeries() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.loadingConsultas[0].cargando = true;
        this.consumerService.update(WebServices.URL_GET_SERIES, body).subscribe(x => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            let emisorConfig: BillingConfiguration[] = x['billingConfigurationsList'];
            emisorConfig = emisorConfig.filter(xx => xx.documentType === TipoDocumento.DESPATCH_ADVICE);
            if (emisorConfig.length === 0) {
                swal({
                    title: 'Obligatorio',
                    text: 'Debe configurar al menos una serie para la guia Remisión del emisor ' +
                        this.util.getCurrentUser().customer.nombre + ' - ' + this.util.getCurrentUser().customer.ruc,
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: true
                }).then((result) => {
                    if (result) {
                        const filtro: any = {};
                        filtro.busqueda = this.util.getCurrentUser().customer.ruc;
                        $('ul#slide-out').removeClass('open');
                        $('i.cerrarAleta').removeClass('open');
                        $('.closePopupNotaDebito').click();
                        this.router.navigate(['/content', {outlets: {'second': ['emisor', this.util.getCurrentUser().customer.id]}}]);
                    }
                });
            } else {
                for (const ec of emisorConfig) {
                    this.options.push(ec.serialNumber);
                }
                if (this.options.length === 1) {
                    this.vld_serie.setValue(this.options[0]);
                }

            }
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }

    agregarItemLista(itemCargado) {

        const itemNew: Grd = new Grd();
        itemNew.numeroOrdenItem = this.template_guiaRemision.guiaRemision.grd.length + 1;
        itemNew.cantidadItem = 1.000;
        itemNew.descripcionItem = itemCargado.description;
        itemNew.nombreItem = itemCargado.description;
        itemNew.codigoItem = itemCargado.productCode;
        itemNew.unidadMedidaItem = itemCargado.measurementUnit.code;


        this.scroll('listItems');
        this.template_guiaRemision.guiaRemision.grd.push(itemNew);
        this.items = this.formGuiaRemision.get('items') as FormArray;
        this.items.push(this.createItem());
    }


    validarExistenciaItem(value: string) {
        let existe = false;
        $.each(this.template_guiaRemision.guiaRemision.det, (pos, item) => {
            if (((item.codigoProducto + ' - ' + item.descripcionProducto) === this.aux_item)) {
                existe = true;
            }
        });
        return existe;
    }

    pad(num: Number, size: number): string {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }

    editReceptor() {
        this.aux_correo = this.template_guiaRemision.guiaRemision.dde.correoElectronico;
        this.aux_telefono = this.template_guiaRemision.guiaRemision.dde.telefono;
        this.aux_direccion = this.template_guiaRemision.guiaRemision.dde.direccion;
        this.aux_razonSocial = this.template_guiaRemision.guiaRemision.dde.razonSocial;
        this.editarReceptor = true;
    }

    guardarCambios() {
        this.template_guiaRemision.guiaRemision.dde.correoElectronico = this.aux_correo;
        this.template_guiaRemision.guiaRemision.dde.telefono = this.aux_telefono;
        this.template_guiaRemision.guiaRemision.dde.direccion = this.aux_direccion;
        this.template_guiaRemision.guiaRemision.dde.razonSocial = this.aux_razonSocial;
        this.editarReceptor = false;
    }

    deshacerCambios() {
        this.aux_correo = this.template_guiaRemision.guiaRemision.dde.correoElectronico;
        this.aux_telefono = this.template_guiaRemision.guiaRemision.dde.telefono;
        this.editarReceptor = false;
    }

    deshabilitarBoton() {
        if (!this.formGuiaRemision.valid) {
            return true;
        }
        if (this.template_guiaRemision.guiaRemision.grd.length === 0) {
            return true;
        }
        if (parseFloat(this.template_guiaRemision.guiaRemision.grc.pesoBrutoBienes) === 0.00) {
            return true;
        }
        if (this.startingPointDepartamento === 'Selecione Departamento' ||
            this.startingPointProvincia === 'Selecione Provincia' ||
            this.startingPointDistrito === 'Selecione Distrito') {
            return true;
        }
        if (this.destinationPointDepartamento === 'Selecione Departamento' ||
            this.destinationPointProvincia === 'Selecione Provincia' ||
            this.destinationPointDistrito === 'Selecione Distrito') {
            return true;
        }

        if (this.reasonTransferValue.code === '13' &&
            this.template_guiaRemision.guiaRemision.ide.notasCaso.trim() == '') {
            return true;
        }

        if (this.trasladoTypeValue.code === '01') {
            if (
                this.template_guiaRemision.guiaRemision.grc.denominacionTransportador === undefined ||
                this.template_guiaRemision.guiaRemision.grc.denominacionTransportador === null ||
                this.template_guiaRemision.guiaRemision.grc.denominacionTransportador === '' ||
                this.template_guiaRemision.guiaRemision.grc.numeroRucTransportista === undefined ||
                this.template_guiaRemision.guiaRemision.grc.numeroRucTransportista === null ||
                this.template_guiaRemision.guiaRemision.grc.numeroRucTransportista === '' ||
                this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC === undefined ||
                this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC === null ||
                this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC === '' ||
                this.template_guiaRemision.guiaRemision.gca.fechaEntregaBienesAlTranportista === undefined ||
                this.template_guiaRemision.guiaRemision.gca.fechaEntregaBienesAlTranportista === null ||
                this.template_guiaRemision.guiaRemision.gca.fechaEntregaBienesAlTranportista === ''
            ) {
                return true;
            }

        }
        if (this.trasladoTypeValue.code === '02') {
            if (
                this.template_guiaRemision.guiaRemision.grc.fechaInicioTraslado === undefined ||
                this.template_guiaRemision.guiaRemision.grc.fechaInicioTraslado === null ||
                this.template_guiaRemision.guiaRemision.grc.fechaInicioTraslado === '' ||
                this.template_guiaRemision.guiaRemision.grc.numeroPlacaVehiculo === undefined ||
                this.template_guiaRemision.guiaRemision.grc.numeroPlacaVehiculo === null ||
                this.template_guiaRemision.guiaRemision.grc.numeroPlacaVehiculo === '' ||
                this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor === undefined ||
                this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor === null ||
                this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor === '' ||
                this.template_guiaRemision.guiaRemision.gca.nomConductor === undefined ||
                this.template_guiaRemision.guiaRemision.gca.nomConductor === null ||
                this.template_guiaRemision.guiaRemision.gca.nomConductor === '' ||
                this.template_guiaRemision.guiaRemision.gca.apeConductor === undefined ||
                this.template_guiaRemision.guiaRemision.gca.apeConductor === null ||
                this.template_guiaRemision.guiaRemision.gca.apeConductor === '' ||
                this.template_guiaRemision.guiaRemision.gca.numLicCondConductor === undefined ||
                this.template_guiaRemision.guiaRemision.gca.numLicCondConductor === null ||
                this.template_guiaRemision.guiaRemision.gca.numLicCondConductor === ''
            ) {
                return true;
            }
        }
        return false;
    }

    divAgregarNewReceptor() {
        this.popupReceptor = true;
        this.receptorNuevo = new Receiver();
        this.docType = [];
        this.docType.push({value: this.DNI, label: 'DNI'});
        this.docType.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
        this.docType.push({value: this.PASAPORTE, label: 'Pasaporte'});
        this.docType.push({value: this.RUC, label: 'RUC'});
        this.docType.push({value: this.DND, label: 'DND'});
        this.receptorNuevo.idDocType = this.RUC;

    }

    divAgregarNuevoProducto() {
        this.popupProducto = true;
    }

    cerrarPopupReceptor() {
        this.popupReceptor = false;
    }

    cerrarPopupProducto() {
        this.popupProducto = false;
    }

    handlerAgregarItemLista(event) {
        this.agregarItemLista(event);
        this.cerrarPopupProducto();
    }

    handlerReceptorNuevo(event) {
        this.optionsRuc.push(event);
        this.template_guiaRemision.guiaRemision.dde.numeroDocId = event.idDocNumber;
        this.cerrarPopupReceptor();
    }

    private _filter(value: string): String[] {
        if (value) {
            const filterValue = value.toLowerCase();
            return this.options.filter(option => option.toLowerCase().includes(filterValue));
        }
    }


    private _filterRuc(value: string): Receiver[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsRuc, (pos, item) => {
            if ((item.idDocNumber === this.template_guiaRemision.guiaRemision.dde.numeroDocId)
                || (item.businessName === this.template_guiaRemision.guiaRemision.dde.numeroDocId)) {
                this.template_guiaRemision.guiaRemision.dde.tipoDocId = item.idDocType;
                this.template_guiaRemision.guiaRemision.dde.numeroDocId = item.idDocNumber;
                this.template_guiaRemision.guiaRemision.dde.razonSocial = item.businessName;
                this.template_guiaRemision.guiaRemision.dde.direccion = item.address;
                this.template_guiaRemision.guiaRemision.dde.telefono = item.phone;
                this.template_guiaRemision.guiaRemision.dde.correoElectronico = item.email;
                // if (this.reasonTransferValue.code === '01') {
                //     this.template_guiaRemision.guiaRemision.grc.direccionPuntoLlegada = item.address;
                //     this.template_guiaRemision.guiaRemision.grc.direccionPuntoPartida = this.usuarioSession.customer.departamento;
                //     this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = this.usuarioSession.customer.ubigeo;
                // }
                $('.espacioCliente').animate({
                    opacity: 1
                }, 1000);
                encontre = true;
            }
        });

        if (!encontre) {
            this.template_guiaRemision.guiaRemision.dde.razonSocial = null;
            this.template_guiaRemision.guiaRemision.dde.direccion = null;
            this.template_guiaRemision.guiaRemision.dde.telefono = null;
            this.template_guiaRemision.guiaRemision.dde.correoElectronico = null;
            $('.espacioCliente').animate({
                opacity: 0
            }, 500);
        }
        const aux = this.optionsRuc.filter(option =>
            ((option.idDocNumber.toLowerCase().includes(filterValue)) ||
                (option.businessName.toLowerCase().includes(filterValue))));
        if (aux !== null && aux.length === 0 && value != null && value.length > 0) {
            this.agregarShowReceptor = true;
        } else {
            this.agregarShowReceptor = false;
        }
        return aux;
    }

    private _filterCodePointStarting(value: string): GrePoint[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCodePointStarting, (pos, item) => {
            if ((item.code === this.template_guiaRemision.guiaRemision.gca.codEstabPuntoPartida)) {
                this.template_guiaRemision.guiaRemision.grc.direccionPuntoPartida = item.address;
                this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = item.ubigeo;
                encontre = true;
            }
        });
        // debugger;
        // if (!encontre && filterValue !== '0000') {
        //     this.template_guiaRemision.guiaRemision.grc.direccionPuntoPartida = '';
        //     this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = '';
        // }
        const aux = this.optionsCodePointStarting.filter(option =>
            ((option.code.toLowerCase().includes(filterValue))));
        return aux;
    }

    private _filterAddressPointStarting(value: string): GrePoint[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCodePointStarting, (pos, item) => {
            if ((item.address.trim() === this.template_guiaRemision.guiaRemision.grc.direccionPuntoPartida.trim())) {
                this.template_guiaRemision.guiaRemision.gca.codEstabPuntoPartida = item.code;
                this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = item.ubigeo;
                encontre = true;
            }
        });
        // if (!encontre) {
        //     this.template_guiaRemision.guiaRemision.gca.codEstabPuntoPartida = '';
        //     this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = '';
        // }
        const aux = this.optionsCodePointStarting.filter(option =>
            ((option.address.toLowerCase().includes(filterValue))));
        return aux;
    }

    private _filterCodePointArrival(value: string): GrePoint[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCodePointArrival, (pos, item) => {
            if ((item.code === this.template_guiaRemision.guiaRemision.gca.codEstabPuntoLlegada)) {
                this.template_guiaRemision.guiaRemision.grc.direccionPuntoLlegada = item.address;
                this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada = item.ubigeo;
                encontre = true;
            }
        });
        // if (!encontre && filterValue !== '0000') {
        //     this.template_guiaRemision.guiaRemision.grc.direccionPuntoLlegada = '';
        //     this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada = '';
        // }
        const aux = this.optionsCodePointArrival.filter(option =>
            ((option.code.toLowerCase().includes(filterValue))));
        return aux;
    }

    private _filterAddressPointArrival(value: string): GrePoint[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCodePointArrival, (pos, item) => {
            if ((item.address.trim() === this.template_guiaRemision.guiaRemision.grc.direccionPuntoLlegada.trim())) {
                this.template_guiaRemision.guiaRemision.gca.codEstabPuntoLlegada = item.code;
                this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada = item.ubigeo;
                encontre = true;
            }
        });
        // if (!encontre) {
        //     this.template_guiaRemision.guiaRemision.gca.codEstabPuntoLlegada = '';
        //     this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada = '';
        // }
        const aux = this.optionsCodePointArrival.filter(option =>
            ((option.address.toLowerCase().includes(filterValue))));
        return aux;
    }

    private _filterCarrierRuc(value: string): GreCarrier[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCarrierRuc.filter(item => item.type === 'PUBLIC'), (pos, item) => {
            if ((item.ruc === this.template_guiaRemision.guiaRemision.grc.numeroRucTransportista)) {
                this.template_guiaRemision.guiaRemision.grc.denominacionTransportador = item.businessName;
                this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC = item.mtcRecord;
                encontre = true;
            }
        });
        if (!encontre) {
            this.template_guiaRemision.guiaRemision.grc.denominacionTransportador = '';
            this.template_guiaRemision.guiaRemision.gca.numeroRegistroMTC = '';
        }
        const aux = this.optionsCarrierRuc.filter(option =>
            ((option.type === 'PUBLIC') && (option.ruc != null) && (option.ruc.includes(filterValue))));
        return aux;
    }

    private _filterCarrierDoc(value: string): GreCarrier[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsCarrierRuc.filter(item => item.type === 'PRIVATE'), (pos, item) => {
            if ((item.documentType == this.typeDocumentDriver.value) && (item.documentNumber === this.template_guiaRemision.guiaRemision.grc.numeroDocIdeConductor)) {
                this.template_guiaRemision.guiaRemision.gca.nomConductor = item.name;
                this.template_guiaRemision.guiaRemision.gca.apeConductor = item.lastName;
                this.template_guiaRemision.guiaRemision.gca.numLicCondConductor = item.licenseNumber;
                encontre = true;
            }
        });
        if (!encontre) {
            this.template_guiaRemision.guiaRemision.gca.nomConductor = '';
            this.template_guiaRemision.guiaRemision.gca.apeConductor = '';
            this.template_guiaRemision.guiaRemision.gca.numLicCondConductor = '';
        }
        const aux = this.optionsCarrierRuc.filter(option =>
            ((option.type === 'PRIVATE') && (option.documentNumber != null) && (option.documentType == this.typeDocumentDriver.value) && (option.documentNumber.includes(filterValue))));
        return aux;
    }

    private _filterItem(value: string): StockProducts[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        $.each(this.optionsItem, (pos, itemCargado) => {
            if (((itemCargado.productCode + ' - ' + itemCargado.description) === this.aux_item)) {
                if (!this.validarExistenciaItem(this.aux_item)) {
                    this.agregarItemLista(itemCargado);
                    this.aux_item = '';
                    this.snackBar.open('Se ha agregado un producto a laguia remisión.', null, {duration: 2000});
                } else {
                    this.aux_item = '';
                    this.snackBar.open('El producto ya se encuentra en la lista. Aumente la cantidad', null, {duration: 2000});
                }
            }
        });

        const aux = this.optionsItem.filter(option =>
            ((option.productCode.toLowerCase().includes(filterValue)) ||
                (option.description.toLowerCase().includes(filterValue))));
        if (aux != null && aux.length === 0 && value != null && value.length > 0) {
            this.agregarShowItem = true;
        } else {
            this.agregarShowItem = false;
        }
        return aux;
    }

    nuevaGuiaRemision() {
        this.additionalDataTmp = [];
        const guiaRemisionTemplate: any = {
            guiaRemision: {
                ide: new Ide(),
                emi: new Emi(this.util.getCurrentUser().customer.ruc,
                    this.util.getCurrentUser().customer.nombre),
                dde: new Dde(),
                grc: new Grc(),
                gca: new Gca(),
                grd: [],
                adi: []
            }
        };
        guiaRemisionTemplate.guiaRemision.ide.codTipoDocumento = '09';
        guiaRemisionTemplate.guiaRemision.grc.pesoBrutoBienes = '0.00';
        guiaRemisionTemplate.guiaRemision.grc.numeroBultos = '0';
        return guiaRemisionTemplate;
    }

    generarADI() {
        this.template_guiaRemision.guiaRemision.adi = [];

        // ADDITIONAL
        this.armarAdditionalData();
    }

    clearReceptor() {
        this.template_guiaRemision.guiaRemision.dde.numeroDocId = '';
        this.template_guiaRemision.guiaRemision.dde.razonSocial = null;
        this.template_guiaRemision.guiaRemision.dde.direccion = null;
        this.template_guiaRemision.guiaRemision.dde.telefono = null;
        this.template_guiaRemision.guiaRemision.dde.correoElectronico = null;
        $('.espacioCliente').animate({
            opacity: 0
        }, 500);
    }

    removeAllDetails() {
        // limpiar tabla de detalle
        for (let i = 0; i < this.template_guiaRemision.guiaRemision.grd.length; i++) {
            this.items.removeAt(0);
        }
        this.template_guiaRemision.guiaRemision.det = [];
    }


    getAdditionalDataPermanent() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumerService.post(WebServices.URL_GET_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            const list = result['additionalDataPermanents'];
            list.forEach((item) => {
                    if (item.documentType === 'DESPATCH_ADVICE') {
                        this.additionalDataPermanent.push({
                            id: item.id,
                            tituloAdicional: item.tituloAdicional,
                            valorAdicional: item.valorAdicional
                        });
                    }

                }
            );
        }, err => {
            console.log('ERROR' + err);
            swal({
                title: 'Error',
                text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });
        });
    }

    armarAdditionalData() {
        if (this.additionalDataPermanent != null && this.additionalDataPermanent.length > 0) {
            this.additionalDataPermanent.forEach(item => {
                this.template_guiaRemision.guiaRemision.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }

        if (this.additionalDataTmp != null && this.additionalDataTmp.length > 0) {
            this.additionalDataTmp.forEach(item => {
                this.template_guiaRemision.guiaRemision.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }
    }

    removeAditionalDataPermanent(pos, item) {
        const body = JSON.stringify({
            additionalDataPermanent: item
        });
        this.removeAdditionalPermanent = true;
        this.consumerService.post<any>(WebServices.URL_DELETE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            this.additionalDataPermanent.splice(pos, 1);
            this.removeAdditionalPermanent = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.removeAdditionalPermanent = false;
            console.log('ERROR' + err);
        });
    }

    removeAditionalDataTmp(pos) {
        this.additionalDataTmp.splice(pos, 1);
    }

    addAdditionalDataTmp() {
        if (this.keyTemp === '' || this.valueTemp === '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        this.additionalDataTmp.push({
            tituloAdicional: this.keyTemp,
            valorAdicional: this.valueTemp
        });
        this.keyTemp = '';
        this.valueTemp = '';
    }

    addAdditionalDataPermanent() {
        if (this.keyPermanent === '' || this.valuePermanent === '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        const body = JSON.stringify({
            additionalDataPermanent: {
                id: this.util.getCurrentUser().customer.id,
                documentType: 'TICKET',
                tituloAdicional: this.keyPermanent,
                valorAdicional: this.valuePermanent,
                logUsernameRegistro: this.util.getCurrentUser().username
            },
            customer: {
                id: this.util.getCurrentUser().customer.id,
                ruc: this.util.getCurrentUser().customer.ruc,
            }
        });
        this.loadingAddDataAditional = true;
        this.consumerService.post<any>(WebServices.URL_SAVE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            const additionalDataPermanent = result['additionalDataPermanent'];
            this.loadingAddDataAditional = false;
            this.additionalDataPermanent.push({
                tituloAdicional: additionalDataPermanent.tituloAdicional,
                valorAdicional: additionalDataPermanent.valorAdicional
            });
        }, err => {
            this.loadingAddDataAditional = false;
            console.log('ERROR' + err);
        });

        this.keyPermanent = '';
        this.valuePermanent = '';

    }

    scroll(id: string) {
        const el = document.getElementById(id);
        el.scrollIntoView();
    }

    getIdByName(name) {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            },
            filename: name,
            documentType: 'DESPATCH_ADVICE'
        });
        this.cargaDocumentos = true;
        setTimeout(() => {
                this.consumerService.update(WebServices.URL_GET_ID_DOCUMENT, body).subscribe(result => {
                    this.cargaDocumentos = false;
                    this.logSeleccionado.id = result['idDocument'];
                    this.logSeleccionado.linkRequestPSE = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PSE&authorization=' + this.util.getJwtToken();
                    this.logSeleccionado.linkRequestXML = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=XML&authorization=' + this.util.getJwtToken();
                    this.logSeleccionado.linkResponseCDR = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=CDR&authorization=' + this.util.getJwtToken();
                    this.logSeleccionado.linkResponsePDF = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PDF&authorization=' + this.util.getJwtToken();
                    this.cd.markForCheck();
                    this.cd.detectChanges();
                }, err => {
                    this.cargaDocumentos = false;
                    this.cd.markForCheck();
                    this.cd.detectChanges();
                    this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
                });
            }, 1000
        );
    }


    changeReasonTransferValue(item) {
        this.reasonTransferValue = item;
        this.template_guiaRemision.guiaRemision.ide.notasCaso = item.description;
    }

    changeTransferType(item) {
        this.trasladoTypeValue = item;
        this.docTypeDriver = [];
        if (this.trasladoTypeValue.code === '01') {
            // PUBLICO
            this.docTypeDriver.push({value: this.RUC, label: 'RUC'});
            this.typeDocumentDriver = {value: this.RUC, label: 'RUC'};
        } else {
            // PRIVADO
            this.docTypeDriver.push({value: this.DNI, label: 'DNI'});
            this.docTypeDriver.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
            this.docTypeDriver.push({value: this.PASAPORTE, label: 'Pasaporte'});
            this.docTypeDriver.push({value: this.DND, label: 'DND'});
            this.typeDocumentDriver = {value: this.DNI, label: 'DNI'};
        }
    }


    setStartPointDepartament(item) {
        this.startingPointDepartamento = item;
        this.masterStartingPointUbigeo.getProvincias(item);
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida = this.masterStartingPointUbigeo.getUbigeoDepartamento(item).substr(0, 2);
        this.startingPointProvincia = 'Selecione Provincia';
        this.startingPointDistrito = 'Selecione Distrito';
        this.masterStartingPointUbigeo.distritos = [];
    }

    setStartPointProvincia(item) {
        this.startingPointProvincia = item;
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida =
            this.masterStartingPointUbigeo.getUbigeoProvincia(item).substr(0, 4);
        this.masterStartingPointUbigeo.getDistritos(item);
        this.startingPointDistrito = 'Selecione Distrito';
    }

    setStartPointDistrito(item) {
        this.startingPointDistrito = item;
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida =
            this.masterStartingPointUbigeo.getUbigeoDistrito(item, this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida);
    }

    setDepProDistStartingPoint() {

        if (this.template_guiaRemision != null &&
            this.template_guiaRemision.guiaRemision != null &&
            this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida != null) {
            const size = this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida.length;
            this.startingPointDepartamento = 'Selecione Departamento';
            this.startingPointProvincia = 'Selecione Provincia';
            this.startingPointDistrito = 'Selecione Distrito';
            if (size > 1) {
                this.startingPointDepartamento =
                    this.masterStartingPointUbigeo.getValueDepartamento(
                        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida);
            }
            if (size > 3) {
                this.startingPointProvincia =
                    this.masterStartingPointUbigeo.getValueProvincia(
                        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida);
            }
            if (size > 5) {
                this.startingPointDistrito =
                    this.masterStartingPointUbigeo.getValueDistrito(
                        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoPartida);
            }
        }
    }


    setDestinationPointDepartament(item) {
        this.destinationPointDepartamento = item;
        this.masterDestinationPointUbigeo.getProvincias(item);
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada =
            this.masterDestinationPointUbigeo.getUbigeoDepartamento(item).substr(0, 2);
        this.destinationPointProvincia = 'Selecione Provincia';
        this.destinationPointDistrito = 'Selecione Distrito';
        this.masterDestinationPointUbigeo.distritos = [];
    }

    setDestinationPointProvincia(item) {
        this.destinationPointProvincia = item;
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada =
            this.masterDestinationPointUbigeo.getUbigeoProvincia(item).substr(0, 4);
        this.masterDestinationPointUbigeo.getDistritos(item);
        this.destinationPointDistrito = 'Selecione Distrito';
    }

    setDestinationPointDistrito(item) {
        this.destinationPointDistrito = item;
        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada =
            this.masterStartingPointUbigeo.getUbigeoDistrito(item,
                this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada);
    }

    setDepProDistDestinationPoint() {
        if (this.template_guiaRemision != null &&
            this.template_guiaRemision.guiaRemision != null &&
            this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada != null) {
            const size = this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada.length;
            this.destinationPointDepartamento = 'Selecione Departamento';
            this.destinationPointProvincia = 'Selecione Provincia';
            this.destinationPointDistrito = 'Selecione Distrito';
            if (size > 1) {
                this.destinationPointDepartamento =
                    this.masterDestinationPointUbigeo.getValueDepartamento(
                        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada);
            }
            if (size > 3) {
                this.destinationPointProvincia =
                    this.masterDestinationPointUbigeo.getValueProvincia(
                        this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada);
            }
            if (size > 5) {
                this.destinationPointDistrito = this.masterDestinationPointUbigeo.getValueDistrito(this.template_guiaRemision.guiaRemision.grc.ubigeoPuntoLlegada);
            }
        }
    }

    isTheCorrectFormatCampoObservacion(cadena) {
        // Expresión regular para verificar alfanuméricos y espacio solamente
        const regex = /^[a-z0-9 \-!"#$%&'()*+,.:;<=>?@_]+$/i;

        // Verificar la longitud de la cadena
        if (cadena.length < 3 || cadena.length > 100) {
            return false;
        }

        // Verificar si la cadena cumple con la expresión regular
        if (!regex.test(cadena)) {
            return false;
        }

        // Verificar que no haya otros caracteres de espacio en blanco aparte de espacio normal
        if (cadena.includes('\n') || cadena.includes('\t') || cadena.includes('\r')) {
            return false;
        }

        // Si todo lo anterior es correcto, la cadena es válida
        return true;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/guia-remision/guia-remision.component.ts